module.exports = __webpack_public_path__ + "img/signup-carousel-second.3edee0b7.png";